import { MedicalRole, UserSex } from '../types';
import { getGenderedMedicalRole } from '../constants/medicalTerminology';

export const MEDICAL_ROLES: Record<MedicalRole, { label: string; priority: number }> = {
  external_collaborator: {
    label: 'Εξωτερικός Συνεργάτης',
    priority: 1
  },
  resident_doctor: {
    label: 'Ειδικευόμενος Γιατρός',
    priority: 2
  },
  specialist_doctor: {
    label: 'Ειδικός Γιατρός',
    priority: 3
  },
  professor: {
    label: 'Καθηγητής',
    priority: 4
  }
};

export function getMedicalRoleLabel(role?: MedicalRole, gender?: UserSex): string {
  if (!role) return '';
  
  // If gender is provided, return gendered role name
  if (gender) {
    return getGenderedMedicalRole(role, gender);
  }
  
  // Default to male form for backwards compatibility
  return MEDICAL_ROLES[role]?.label || '';
}

export function getMedicalRolePriority(role?: MedicalRole): number {
  if (!role) return 0;
  return MEDICAL_ROLES[role]?.priority || 0;
}

export function getMedicalRoleOptions(gender: UserSex = 'male'): Array<{ value: MedicalRole; label: string }> {
  return Object.entries(MEDICAL_ROLES).map(([value, config]) => ({
    value: value as MedicalRole,
    label: getGenderedMedicalRole(value as MedicalRole, gender)
  }));
}

// New gender-aware helper functions
export function getGenderedMedicalRoleLabel(role: MedicalRole, gender: UserSex): string {
  return getGenderedMedicalRole(role, gender);
}

// Helper to format medical role display with proper Greek grammar
export function formatMedicalRoleDisplay(role?: MedicalRole, gender?: UserSex, firstName?: string, lastName?: string): string {
  if (!role) return '';
  
  const genderedRole = gender ? getGenderedMedicalRole(role, gender) : MEDICAL_ROLES[role]?.label || '';
  
  if (firstName && lastName) {
    return `${genderedRole} ${firstName} ${lastName}`;
  }
  
  return genderedRole;
}